import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './BannerTheme.css';
import getConfig from './Config';
import { initSentryLazy } from '../../sentry';

/**
 * NOTE: if you do not want to use the cookie consent banner, you should
 * run `npm uninstall vanilla-cookieconsent`, and delete this component, its config file,
 * as well as its import in src/client/App.tsx .
 */
const CookieConsentBanner = () => {
  useEffect(() => {
    CookieConsent.run(getConfig());

    // Handle returning visitors who already gave functional consent.
    if (CookieConsent.acceptedCategory('functional')) {
      initSentryLazy();
    }
  }, []);

  return <div id="cookieconsent"></div>;
};

export default CookieConsentBanner;
